import QueryWhereLeftBracket from '../../../query/remote/QueryWhereLeftBracket';
import QueryWhereRightBracket from '../../../query/remote/QueryWhereRightBracket';
import StringUtil from '../../../utils/StringUtil';

export default class FormParamCondition
{
	remoteClass = "gongqi.erp.gotmodel.form.remote.FormParamCondition";
	items;
	_sqlWhereStr;
	static getSqlWhereStr()
	{
		if(this._sqlWhereStr)
			return this._sqlWhereStr;
		var i = 0;
		var result = "";
		var leftBracket = QueryWhereLeftBracket.None;
		var rightBracket = QueryWhereRightBracket.None;
		for(let i = 0;i<this.items.length;i++)
		{
			let item = this.items[i];
			if(i > 0)
			{
				result += (" " + item.andOr);
			}
			
			
			if(item.leftBracket!=QueryWhereLeftBracket.None)
			{
				result += (" " + QueryWhereLeftBracket.labelOf(item.leftBracket));
				leftBracket += item.leftBracket;
			}
			
			if(item.value == null)
				item.value = "";
			
			if(item.value.indexOf(",") != -1)
				var fieldValues = item.value.split(",");
			else
				fieldValues = [item.value];
			
			if(fieldValues.length > 1)
				result += " (";
			
			for(let j = 0;j<fieldValues.length;j++)
			{
				let _fv = fieldValues[j];	
				if(j > 0)
				{
					result += (" or " + (item.type=="MenuItemId"?".menuItemId":(item.type=="CallerMenuItemId"?".callerMenuItemId":(item.type=="CallerLookupField"?".callerLookupField":".fieldName")))+"="+StringUtil.trimThrough(_fv));
					//result += (" or " + (item.type=="MenuItemId"?".menuItemId":".fieldName")+"="+StringUtil.trimThrough(_fv));	
				}
				else
				{
					result += (" "+(item.type=="MenuItemId"?".menuItemId":(item.type=="CallerMenuItemId"?".callerMenuItemId":(item.type=="CallerLookupField"?".callerLookupField":".fieldName")))+"="+StringUtil.trimThrough(_fv));
					//result += (" "+(item.type=="MenuItemId"?".menuItemId":".fieldName")+"="+StringUtil.trimThrough(_fv));
				}
			}
			
			if(fieldValues.length > 1)
				result += " )";
			
			//if(item.rightBracket != 0)
			//	item.rightBracket = 0;
			
			if(item.rightBracket!=QueryWhereRightBracket.None)
			{
				result += (" " + QueryWhereRightBracket.labelOf(item.rightBracket));
				rightBracket += item.rightBracket;
			}
		}
		
		if(leftBracket != rightBracket)
		{
			//GongqiAlert.show("括号不匹配");
			return "";
		}
		
		this._sqlWhereStr = result;
		return result;
	}
}


// WEBPACK FOOTER //
// ./src/forms/sys/remote/FormParamCondition.js